interface FreshAddressResponseInterface {
  enabled?: boolean;
  COMMENT: string;
  COMMENT_CODE: string;
  EMAIL: string;
  ERROR: string;
  ERROR_RESPONSE: string;
  FINDING: string;
  SUGG_COMMENT: string;
  SUGG_EMAIL: string;
  UUID: string;
}

interface BuiltValidatorResponse {
  valid: boolean;
  suggestion?: string;
}

function buildResult(response: FreshAddressResponseInterface): BuiltValidatorResponse {
  if (response.enabled === false) return { valid: true };
  const valid = response.FINDING === 'V';
  const result: BuiltValidatorResponse = { valid };

  // empty strings are falsey in javascript so even though SUGG_EMAIL
  // is set to '' when empty, we won't set suggestion on the result
  if (response.SUGG_EMAIL) {
    result.suggestion = response.SUGG_EMAIL;
  }

  return result;
}

export default async function validateEmail(
  emailValidatorUrl: string,
  email: string
): Promise<BuiltValidatorResponse> {
  const requestUrl = new URL(emailValidatorUrl);

  const response = await fetch(requestUrl.toString(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  });
  const json = await response.json();

  return buildResult(json);
}
